class LoadMoreButton extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('button');
    this.productGridContainer = document.getElementById('ProductGridContainer');
  }

  connectedCallback() {
    if (this.button) this.button.addEventListener('click', this.handleClick.bind(this));
  }

  disconnectedCallback() {
    if (this.button) this.button.removeEventListener('click', this.handleClick.bind(this));
  }

  async handleClick(event) {
    const nextUrl = this.dataset.nextUrl;
    if (!nextUrl) {
      this.style.display = 'none';
      return;
    }

    this.button.innerText = 'Loading...';
    this.button.disabled = true;

    try {
      const response = await fetch(nextUrl);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newProducts = doc.querySelector('#ProductGridContainer #product-grid');
      const productGrid = this.productGridContainer.querySelector('#product-grid');

      if (newProducts && productGrid) {
        productGrid.insertAdjacentHTML('beforeend', newProducts.innerHTML);
      }

      // Find the new Load More button container in the fetched HTML
      const newLoadMoreButtonContainer = doc.querySelector('load-more-button');

      if (newLoadMoreButtonContainer) {
        // Find the next URL and update the current component's data attribute
        const nextUrlFromNewComponent = newLoadMoreButtonContainer.dataset.nextUrl;
        if (nextUrlFromNewComponent) {
          this.dataset.nextUrl = nextUrlFromNewComponent;
          this.style.display = 'flex'; // Ensure button is visible if it was hidden
        } else {
          this.style.display = 'none'; // Hide if no more pages
        }
      } else {
        // No new button found, so we've reached the last page. Hide the current one.
        this.style.display = 'none';
      }
    } catch (error) {
      console.error('Error loading more products:', error);
      this.button.innerText = 'Error';
    } finally {
      this.button.innerText = 'Load More';
      this.button.disabled = false;
    }
  }
}

customElements.define('load-more-button', LoadMoreButton);
